'use client';

import { Link } from 'react-router-dom';

export default function FeaturesSection() {
  return (
    <div className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            통합 물 관리 시스템
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            최첨단 기술과 지능형 자동화를 통해 물 시스템을 모니터링, 제어 및
            최적화합니다
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <Link to="https://bs.sieng.co.kr/">
            <button className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 text-center transition-all duration-300 hover:shadow-xl hover:scale-105 cursor-pointer group">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-blue-600 rounded-2xl relative overflow-hidden">
                <i className="ri-dashboard-line text-2xl text-white absolute transition-all duration-300 group-hover:opacity-0 group-hover:-translate-x-4"></i>
                <i className="ri-arrow-right-line text-2xl text-white absolute transition-all duration-300 opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                실시간 가압장 모니터링
              </h3>
              <p className="text-gray-600">
                고급 센서 네트워크를 통해 수질, 유량, 압력 수준 및 시스템 성능을
                실시간으로 추적합니다
              </p>
            </button>
          </Link>

          <Link to="https://sieng.co.kr/">
            <button className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 text-center transition-all duration-300 hover:shadow-xl hover:scale-105 cursor-pointer group">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-green-600 rounded-2xl relative overflow-hidden">
                <i className="ri-leaf-line text-2xl text-white absolute transition-all duration-300 group-hover:opacity-0 group-hover:-translate-x-4"></i>
                <i className="ri-arrow-right-line text-2xl text-white absolute transition-all duration-300 opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                친환경 수위 모니터링
              </h3>
              <p className="text-gray-600">
                지능형 보존 알고리즘을 통해 물 사용량을 최적화하고, 낭비를
                줄이며, 지속 가능한 관행을 구현합니다
              </p>
            </button>
          </Link>

          <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-purple-600 rounded-2xl">
              <i className="ri-brain-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              AI 기반 분석
            </h3>
            <p className="text-gray-600">
              예측 유지보수, 이상 탐지 및 운영 최적화를 위한 머신러닝을
              활용합니다
            </p>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-orange-600 rounded-2xl">
              <i className="ri-alarm-warning-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              경보 시스템
            </h3>
            <p className="text-gray-600">
              중요한 이벤트, 유지보수 필요 사항 및 시스템 이상에 대한 다중 채널
              즉시 알림
            </p>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-teal-600 rounded-2xl">
              <i className="ri-settings-3-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">원격 제어</h3>
            <p className="text-gray-600">
              안전한 액세스와 자동 스케줄링을 통해 펌프, 밸브 및 처리 시스템을
              원격으로 제어합니다
            </p>
          </div>

          <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-pink-600 rounded-2xl">
              <i className="ri-file-chart-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              규정 준수 보고
            </h3>
            <p className="text-gray-600">
              규제 요구사항 및 표준을 충족하기 위한 상세한 규정 준수 보고서 및
              문서를 생성합니다
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
